
<div class="h-95px d-flex justify-content-center align-items-center">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="4"  animationDuration="1.2s"></p-progressSpinner>
</div>

